import {createAction} from "redux-act";
import {
	LeaderboardUsersType,
	LeaderboardsTabsType,
	PredictionResult,
	UserLeaderboardClass,
} from "modules/enums";

interface IFetchLeaderboard {
	season?: number;
	page: number;
	limit: number;
	usersType: LeaderboardUsersType;
	ranksType: LeaderboardsTabsType;
	roundId?: number;
	leagueId?: number;
	haveToClear?: boolean;
	isPrevLeaderboard?: boolean;
}

export interface ILeaderboardResponse {
	ranks: IRankUser[];
	user: (IRankUser & {page: number | null}) | null;
	nextPage: boolean;
	friendsParticipantsCount: number;
	allParticipantsCount: number;
	updatedAt: string;
}

export interface IRankUser {
	userId: number;
	rank: number;
	username: string;
	avatar: null | string;
	level: number | null;
	levelColor: string | null;
	levelName: string | null;
	streak: number;
	predictions: IPredictionsHistory;
	userType: UserLeaderboardClass;
}

export const fetchLeaderboard = createAction<IFetchLeaderboard>();
export const fetchLeaderboardSuccess = createAction<ILeaderboardResponse>();
export const fetchLeaderboardFailed = createAction();
export const clearLeaderboard = createAction();
export const clearFetchedPagesLeaderboards = createAction();

interface IFetchLeaderProfile {
	userId: number;
}

export const fetchLeaderProfile = createAction<IFetchLeaderProfile>();

export interface IFavouriteBatter {
	playerId: number;
	selectionsCount: number;
}

export interface IPredictionsHistory {
	roundId: number;
	result: PredictionResult | null;
	streak: number | null;
	streakIncrease: number | null;
	roundPredictions: IUserProfilePrediction[];
}

export interface IUserProfilePrediction {
	number: number;
	unitId: number;
	playerId: number;
	result: PredictionResult | null;
	hits: number;
	atBats: number;
}

export interface IUserProfile {
	activeStreak: number;
	seasonBestStreak: number;
	accuracy: number;
	favouriteBatter: IFavouriteBatter;
	predictions: IPredictionsHistory[];
}

export const fetchLeaderProfileSuccess = createAction<IUserProfile>();
export const fetchLeaderProfileFailed = createAction();
export const showUpdateNotice = createAction<boolean>();
